import { styled } from '@lessonup/ui-components';
import React, { PropsWithChildren, RefObject } from 'react';

export interface PollPinTextAnswerAreaProps {
  containerRef?: RefObject<HTMLDivElement | null>;
}

export const PollTextAnswerContainer: React.FC<PropsWithChildren<PollPinTextAnswerAreaProps>> = ({
  containerRef,
  children,
}) => {
  return (
    <StyledAnswerAreaContentWrapper>
      <StyledAnswerAreaContent ref={containerRef}>{children}</StyledAnswerAreaContent>
    </StyledAnswerAreaContentWrapper>
  );
};

const StyledAnswerAreaContentWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledAnswerAreaContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 40%;
  max-width: 80%;
`;
